// Tiny localStorage-backed "have they seen this onboarding bit?" tracker.
// Keyed by id ('intro', 'tour.main', 'tour.players', 'tour.champions') so each
// piece fires at most once. Bump SCHEMA to re-show everything after a big change.
const KEY = 'wiznaibOnboarding.v1';

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; } };

export function onboardSeen(id) { return read()[id] === true; }

export function markOnboardSeen(id) {
  try { const o = read(); o[id] = true; localStorage.setItem(KEY, JSON.stringify(o)); } catch { /* private mode / quota */ }
}

// Let the user replay everything (e.g. from a "show intro again" link).
export function resetOnboarding() { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }

// `?intro` in the URL force-replays the onboarding (for testing / a replay link).
export function introForced() { try { return new URLSearchParams(window.location.search).has('intro'); } catch { return false; } }
